import { Auth } from "aws-amplify";

export default () => Auth.signOut();
